import * as popUpStyles from '../../styles/layout/search-pop-up.module.scss';

import React, {useEffect, useMemo} from 'react';
import PropTypes from 'prop-types';
import AlgoliaResults from '../../algolia/AlgoliaResults';
import IconContainer from '../../components/shared/IconContainer';
import Search from '../../components/shared/filter/Search';
import Title from '../../components/shared/Title';
import algoliasearch from 'algoliasearch';
import {getFilteredAlgoliaResults} from '../../utils/parsing';
import {useTranslation} from 'react-i18next';

/* const hitsToMultipleIdxSearchHits = (hits, idx) => {
  let website = null
  Object.keys(idxToUriMap).forEach(key => {
    if (idx.indexOf(key) !== -1) {
      website = idxToUriMap[key]
    }
  })
  if (website === null) {
    return []
  }
  return hits.map(el => {
    return {
      website,
      ...el
    }
  })

} */

const SearchPopUp = ({websiteRoot, language, handleClose}) => {
  const client = useMemo(() => (
    algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_KEY)
  ), []);
  const index = useMemo(() => (client.initIndex( process.env.GATSBY_ALGOLIA_INDEX_NAME )), [client]);
  const [searchWord, setSearchWord] = React.useState('');
  const [results, setResults] = React.useState(null);
  const {t} = useTranslation();
  const getSearchWords = React.useCallback(function async (searchWords) {
    setSearchWord(searchWords);
  }, []);

  const searchContentFilter =
  (
    ['news', 'event'].map(el => `type:"${el}"`).join(' OR ')
  );

  useEffect(() => {
    const getHits = async () => {
      const hitsPromises = [
        index.search(searchWord, {
          filters: 'type: "internalpage"',
          hitsPerPage: 7
        }),
        index.search(searchWord, {
          filters: searchContentFilter,
          hitsPerPage: 14
        }),
        index.search(searchWord, {
          filters: 'type: "exedproduct"',
          hitsPerPage: 7
        }),
        index.search(searchWord, {
          filters: 'type: "people"',
          hitsPerPage: 7
        })
      ];
      const resolved = ((
        await Promise.all(hitsPromises)
          .catch(err => {
            console.error(err);
          })
      ) || []).map(
        r => r.hits
      );
      if (resolved) {
        const hits = resolved.flat(1);
        const filtered = getFilteredAlgoliaResults(hits);
        setResults(filtered);
      }
    };

    getHits();
  }, [searchWord, index, searchContentFilter]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleClose();
    }
  };

  return (
    <div
      className={popUpStyles.container}
      tabIndex={-1}
    >
      <div className={popUpStyles.titleContainer}>
        <Title className={popUpStyles.title}
          id="modal-modal-title"
          label={t('search.title')}
        />
        <button
          aria-label={t('search.window.close')}
          onClick={() => handleClose()}
          onKeyDown={handleKeyDown}
          tabIndex="0"
        >
          <IconContainer color="BLACK"
            icon="MENU_CLOSE"
            label={t('search.close')}
            notHidden
            size={20}
            tabIndex={-1}
          />
        </button>
      </div>
      <p className={popUpStyles.h6TextInform}> {t('search.message')} </p>
      <div style={{marginBottom: 20}}>
        <Search getSearchWords={getSearchWords}/>
      </div>
      <p className={popUpStyles.h6TextTitle}>
        Resultats de recherche pour votre recherche <b><i>&quot;{searchWord}&quot;</i></b>
      </p>
      {results && results.length > 0 &&
      <AlgoliaResults
        language={language}
        results={results}
        searchWord={searchWord}
        websiteRoot={websiteRoot}
      />}{(!results || !results.length > 0) &&
        <div>{t('search.noResult')}</div>
      }
    </div>
  );
};

SearchPopUp.propTypes = {
  handleClose: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  websiteRoot: PropTypes.string.isRequired,
};

export default SearchPopUp;
